/* eslint-disable @typescript-eslint/no-throw-literal */
import React from 'react';
import Page from 'components/misc/BasePage/Blog';
import ApiError from 'api/error';
import AuthorContent from 'pageContents/BlogContent/AuthorContent';
import BlogSubHeader from 'components/blog/BlogSubHeader';
import blogApi from 'entity/blog/blogApi';
import { Head } from 'app/components/blog/author';
import {
  ArticleAuthorApiResponse,
  GetArticlesByCategoryParams,
} from 'entity/blog/blogTypes';

interface OwnProps {
  authorArticles: {
    articleResponse: ArticleAuthorApiResponse;
    articleParams: GetArticlesByCategoryParams;
  };
}

const Author = (props: OwnProps) => {
  const { authorArticles } = props;
  const { author } = authorArticles.articleResponse.data;
  return (
    <Page renderSubHeader={() => <BlogSubHeader />}>
      <Head author={author} />
      <AuthorContent authorArticles={authorArticles} />
    </Page>
  );
};

Author.getInitialProps = async ({ query }) => {
  const { authorSlug } = query;
  const authorParams = {
    orderBy: 'publishDate',
    slug: authorSlug,
    page: 1,
    perPage: 10,
  };
  const authorResponse = await blogApi.getArticlesByAuthor(authorParams);

  if (!authorResponse.ok) {
    const apiError = new ApiError(authorResponse);
    throw apiError;
  }

  return {
    authorArticles: {
      articleResponse: authorResponse,
      articleParams: authorParams,
    },
  };
};

export default Author;
